module.exports = __webpack_public_path__ + "static/AnnieWang-ef42a2f388700ed4728e850bf7b2e9e2.png";